import type { PartySide } from '@saledeed/shared';

/** A change the editor can make for the admin with one click. */
export type IssueFix =
  | { kind: 'makePartyField'; field: string }
  | { kind: 'switchSide'; side: PartySide };

export interface Issue {
  severity: 'error' | 'warning';
  code: string;
  /** Location in the template or fill, e.g. blocks[3].entries[1]. Never a value. */
  path: string;
  message: string;
  fix?: IssueFix;
}

export function hasErrors(issues: readonly Issue[]): boolean {
  return issues.some(i => i.severity === 'error');
}

/**
 * Warnings that still let the admin save, but not publish: executives would get
 * a form that does not match the deed (a seller's details asked once for all
 * sellers, or no place to enter the sellers at all).
 */
const NOT_READY = new Set(['field.documentFieldInPartyOnly', 'party.missingSide']);

export function notReadyIssues(issues: readonly Issue[]): Issue[] {
  return issues.filter(i => NOT_READY.has(i.code));
}
